import classNames from "classnames/bind";
import styles from "./Notification.module.css";
import TableAdminNotification from "./TableAdminNotification";
import ModalAddNotification from "./ModalAddNotification";
import { useEffect, useState } from "react";
import { SearchBlack } from "../../../components/Icons/Icons";
import { Toast } from "../../../components";
import { notificationApi } from "../../../services/api/notificationApi";
import ModalShowUser from "./ModalShowUser/ModalShowUser";

const cx = classNames.bind(styles);

function Notification() {
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [searchFill, setSearchFill] = useState("");
  const [name, setName] = useState("");
  const [typeNotification,setTypeNotification] = useState()
  const [title,setTitle] = useState()
  const [code, setCode] = useState();
  const getShowModal = (code, name) => {
    setShowModal(!showModal);
    setCode(code);
    setName(name);
  };
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    async function getNotification() {
      try {
        const res = await notificationApi.getAllType();
        setNotifications(res);
        setTypeNotification(res[0].CODE)
      } catch (e) {
        Toast.open("Lấy danh sách loại thông báo không thành công", "danger");
      }
    }
    getNotification();
  }, [isLoading]);
  const handleSearchValue = (e) => {
    setSearchFill(e.target.value);
  };
  
  const onClose = ()=>{
    setShowModal(false)
  }
  return (
    <>
      {showModal && <ModalShowUser  title={title} onClose={onClose} typeNotification={typeNotification}/>}
      <div className={cx("header")}>
        <h1 className={cx("user-name")}>{"Quản trị thông báo"}</h1>
      </div>
      <div className={cx("content")}>
        <TableAdminNotification
          notifications={notifications}
          showDetailInfo={(code, name) => getShowModal(code, name)}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setShowModal={setShowModal}
          setTypeNotification={setTypeNotification}
          setTitle={setTitle}
        />
      </div>
    </>
  );
}

export default Notification;
